import * as Factory from 'factory.ts'
import faker from 'faker'

import { type FinancialAccountBankingDetailsApiModel } from '../FinancialAccountBankingDetailsApiModel'

export const FinancialAccountBankingDetailsApiModelStub =
  Factory.Sync.makeFactory<FinancialAccountBankingDetailsApiModel>({
    account_name: Factory.each(() => faker.finance.accountName()),
    account_number: Factory.each(() => faker.finance.account(10)),
    routing_number: Factory.each(() => faker.finance.account(9)),
    institution_number: Factory.each(() => faker.finance.account(3)),
    transit_number: Factory.each(() => faker.finance.account(5)),
    sort_code: Factory.each(() => faker.finance.account(6)),
  })
